import { DialogContent, Stack } from "@mui/material"
import { DialogActions, DialogHandler, DialogTitle, ListModel, TextField } from "@cakemail-org/ui-components-v2"
import { t } from "i18next"
import { ChangeEvent, KeyboardEvent, MouseEvent, useState } from "react"
import ListSearch from "../../searchDropdowns/ListSearch"
import { TCreateResourceDialogContent, TCreateResourceDialogPromise, TShowCreateResource } from "./types"
import "./styles.scss"

export async function showCreateResourceDialog({ titleKey, addList }: TShowCreateResource): Promise<TCreateResourceDialogPromise> {
    return new Promise((resolve, reject) => {
        DialogHandler.show({
            content: <CreateResourceDialogContent resolve={resolve} reject={reject} titleKey={titleKey} addList={addList} />,
            managedByContent: true
        })
    })
}

export function CreateResourceDialogContent({
    resolve,
    reject,
    titleKey,
    addList
}: TCreateResourceDialogContent) {
    const [value, setValue] = useState<string>("")
    const [selectedList, setSelectedList] = useState<ListModel>()


    function hasError() {
        return value == "" && (addList && selectedList == undefined)
    }

    function handleKeyDown(event: KeyboardEvent<HTMLInputElement>) {
        if (event.key === "Enter") {
            const confirmButton = document.querySelector('.createResourceDialog button:last-child') as HTMLButtonElement
            if (confirmButton && !hasError()) {
                confirmButton.click()
            }
        }
    }

    function handleConfirm(event: MouseEvent<HTMLButtonElement>, btnRef: any) {
        resolve({ event, btnRef, list: selectedList, name: value })
    }
    function handleCancel() {
        DialogHandler.hide()
        reject()
    }

    function handleListChange(list: ListModel) {
        setSelectedList(list)
    }

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        const { value } = event.currentTarget
        setValue(value)
    }

    return <Stack className="createResourceDialog" >
        <DialogTitle variant="h2">
            {t(titleKey)}</DialogTitle>
        <DialogContent>
            <TextField
                label={t("general-name")}
                onChange={handleChange}
                value={value}
                onKeyDown={handleKeyDown}
            />

            {addList &&
                <ListSearch
                    label={t("general-list")}
                    onChange={handleListChange}
                    onFirstListLoaded={handleListChange}
                />
            }
        </DialogContent>
        <DialogActions
            primaryBtnText={t("general-confirm")}
            primaryBtnOnClick={handleConfirm}
            primaryBtnDisabled={hasError()}
            secondaryBtnText={t("general-cancel")}
            secondaryBtnOnClick={handleCancel}
        />
    </Stack >
}